var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Loadable"},[(_vm.loading)?_c('Loading',{attrs:{"loading":_vm.loading,"size":"100"}}):_c('div',{staticClass:"Loadable__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }